import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=4fe6527f&scoped=true&"
import script from "./AboutHeader.vue?vue&type=script&lang=js&"
export * from "./AboutHeader.vue?vue&type=script&lang=js&"
import style0 from "./AboutHeader.vue?vue&type=style&index=0&id=4fe6527f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6527f",
  null
  
)

export default component.exports